import { render } from "./OneBonus.vue?vue&type=template&id=38c507ed&scoped=true"
import script from "./OneBonus.vue?vue&type=script&lang=js"
export * from "./OneBonus.vue?vue&type=script&lang=js"

import "./OneBonus.vue?vue&type=style&index=0&id=38c507ed&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c507ed"]])

export default __exports__